//label_蔵人おすすめ
        $(document).ready(function(){
        var month = new Date().getMonth() + 1; // 現在の月を取得（0からカウントだからわかりやすく+1する）
        
        var seasonClass = '';
        if(month >= 3 && month <= 5){
            // 春
            seasonClass = 'spring';
        }else if(month >= 6 && month <= 8){
            // 夏
            seasonClass = 'summer';
        }else if(month >= 9 && month <= 11){
            // 秋
            seasonClass = 'autumn';
        }else{
            // 冬
            seasonClass = 'winter';
        }
        
        $('.kurabito').addClass(seasonClass); // 指定要素にクラスを追加する
        });

document.addEventListener("DOMContentLoaded", function() {
  var form = document.querySelector('form[action="/cart/add"]');

  // フォームが存在するかどうかを確認
  if (form) {
    form.addEventListener('submit', function(event) {
      event.preventDefault();

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest' // This header is for Shopify to return a JSON response
        }
      })
      .then(response => response.json())
      .then(data => {
        // Handle successful addition to cart. You can add any notification here.
        alert('商品がカートに追加されました！');
      })
      .catch(error => {
        console.error('Error adding item to cart:', error);
        alert('カートに商品を追加する際にエラーが発生しました。');
      });
    });
  }
});

//クリスマスギフトの表示を書き換える
document.addEventListener("DOMContentLoaded", function() {
    const productSubtitles = document.querySelectorAll('.productSubtitle'); // 複数の要素を考慮
    productSubtitles.forEach(subtitle => {
        const text = subtitle.textContent.trim();
        if (text === "【クリスマスギフト】") {
            subtitle.innerHTML = '【🎁<span style="color: red;">クリスマスギフト</span>🎁】';
        } else if (text === "【バレンタインギフト】") {
            subtitle.innerHTML = '【🎁バレンタインギフト🎁】';
        }
    });
});



